import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import Form from './form';
import {
  CancellationAireFormVM,
  DocumentSectionVM,
} from 'cancellations/view-models/cancellation-aire';

interface AccordionDocumentProps {
  disabled?: boolean;
}

const AccordionDocumentComponent = ({
  disabled = false,
}: AccordionDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CancellationAireFormVM>();

  const onChange = useEventCallback(
    (key: keyof DocumentSectionVM, value: DocumentSectionVM[keyof DocumentSectionVM]) => {
      formContext.setFieldValue('document', {
        ...(formContext.values.document || {}),
        [key]: value,
      });
    }
  );

  const onChanges = useEventCallback((values: DocumentSectionVM) => {
    formContext.setFieldValue('document', {
      ...(formContext.values.document || {}),
      ...(values || {}),
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-attachments-content"
        id="accordion-attachments-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.document ? <Close color="error" /> : <Check color="success" />}
        <Typography>Documenti</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form
          onChange={onChange}
          onChanges={onChanges}
          values={formContext.values.document}
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionDocumentComponent.displayName = 'accordion Document';

const AccordionDocument = memo(AccordionDocumentComponent);

export default AccordionDocument;
